import Axios from "axios";

export default {
  // Метод поиска
  SearchUsers(context, data) {
    context.commit('SET__searchText', data.searchText) // записал активную строку по поиску
    context.commit('SET__searchProfile', data.searchProfile);
    context.commit('SET__searchDates', data.searchDates);
    context.commit('SET__searchStatus', data.searchStatus);
    async function searchInServer(stringSearch) {
      context.commit('SET__loading', true);
      const res = await Axios.post(stringSearch, {
        query: data.searchText,
        profile: data.searchProfile,
        from: data.searchDates.split(',')[0],
        to: data.searchDates.split(',')[1],
        status: data.searchStatus
      });
      if(res.data) {
        context.commit('SET__AllData',res.data )
      }
      context.commit('SET__loading', false);
    }
    let stringSearch = `/hr/candidate/search/resume/?vacancy_id=${data.id}&page=1`
    searchInServer(stringSearch);
  },
  // метод догрузки пользователей
  usersLoading(context, data) {
    context.commit('SET__loading', true);
    context.commit('SET__activePage');
    console.log(context.getters);
    async function usersLoadingNewxtPage(stringSearch) {
      // const searchText = context.getters['searchText'];
      // const searchProfile = context.getters['searchProfile'];
      // const searchDates = context.getters['searchDates'];
      // const searchStatus = context.getters['searchStatus'];
      const res = await Axios.get(stringSearch);
      if(res && res.data) {
        context.commit('SET__AddNewData', res.data)
      }
      context.commit('SET__loading', false);
    }
    let activePage = context.getters['activePage'];
    let usersLoadingSearchNext = `/hr/candidate/search/resume/?vacancy_id=${data.vacancy_id}&page=${activePage}`
    usersLoadingNewxtPage(usersLoadingSearchNext);
  }
}
